import React from 'react';
import { Combo } from 'fw/forms';
import * as API from 'modules/app/API'

class PaypalInvoiceStatusCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    componentDidMount = () => {
        this._isMounted = true;

        this.load(this.props.queueTypeCode);
    }

    load = () => {
        API.Admin.get('/paypalInvoice/getPaypalInvoiceStatus', { },
            {
                success: (r) => {
                    this._isMounted && this.setState({
                        items: r.data.items.map((item) => { return { label: item.description, value: item.externalStatusCode } }),
                    });
                }
            }, { block: false });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <Combo
                {...this.props}
                placeholder={this.props.placeholder ? this.props.placeholder : "Invoice Status"}
                items={this.state.items}
                searchable={true}
                ref={(c) => { this._ctrl = c }} />
        )
    }
}

export default PaypalInvoiceStatusCombo;

// Mark this as a form component
PaypalInvoiceStatusCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/paypalInvoiceStatusCombo/PaypalInvoiceStatusCombo.js